import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAllUsersShort } from '../../reducers/user/duck';
import {
  getChartReport,
  getChartCompareReport,
  resetChartCompareReport,
  resetChartReport,
  getExport,
  getTableReport, getCurrentDate,
} from '../../reducers/dashboard/duck';
import { getApps } from '../../reducers/create-app/duck';
import { getAppCampaigns } from '../../reducers/create-campaign/duck';
import OverviewScreen from './OverviewScreen';

const mapStateToProps = ({
  dashboardStore: {
    chartReport,
    chartCompareReport,
  },
  userStore: {
    hasMoreUsersShort,
    pageUsersShort,
    usersShort,
    usersShortStatus,
    sidebarStatus,
  },
  createAppStore: {
    apps,
    pageApps,
    getAppsStatus,
    hasMoreApps,
  },
  campaignStore: {
    currentAppCampaigns,
  },
}) => ({
  chartReport,
  chartCompareReport,
  hasMoreUsersShort,
  pageUsersShort,
  usersShort,
  usersShortStatus,
  apps,
  pageApps,
  getAppsStatus,
  hasMoreApps,
  currentAppCampaigns,
  sidebarStatus,
});

const mapDispatchToProps = {
  getAllUsersShort,
  getChartReport,
  getTableReport,
  getAppCampaigns,
  getChartCompareReport,
  getApps,
  resetChartCompareReport,
  resetChartReport,
  getExport,
  getCurrentDate,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(OverviewScreen));



// WEBPACK FOOTER //
// ./src/containers/OverviewScreen/index.js